export default __webpack_public_path__ + "23e5c37ad572dd0afbdfcd70e3b2e33b.svg";